import { Box, Divider } from "@bca/ui-library";

import Filter from "../../Interfaces/Filter";
import SortOption from "../../Interfaces/SortOption";
import SortOptionsMobile from "../../Sort/SortOptionsMobile";
import DateRange from "../DateRange";
import {
  NUMBER_OF_DAYS_OPTIONS,
  PurchasesUrlQueryParams,
} from "../../APICalls/buildGetPurchasesUrl";
import { AppliedCheckboxResult } from "../../Hooks/useAppliedCheckBoxes";
import FilterCategories from "../FilterCategories";

interface ContentProps {
  setIsScrolledToTop: (isScrolledToTop: boolean) => void;
  finalFilter: NUMBER_OF_DAYS_OPTIONS | string;
  setModalSelectedFilter: (event: NUMBER_OF_DAYS_OPTIONS) => void;
  filters: Filter[];
  modalSelectedSortOption: string;
  onSortHandler: (event: React.ChangeEvent<HTMLInputElement>) => void;
  sortOptions: SortOption[];
  modalSelectedFilter: NUMBER_OF_DAYS_OPTIONS | string;
  setTotalResults: React.Dispatch<React.SetStateAction<number>>;
  modalPurchasesUrlParams: PurchasesUrlQueryParams;
  setModalAdditionalFilters: any;
  isToUseAuthZero?: boolean;
}

const Content: React.FunctionComponent<
  ContentProps & AppliedCheckboxResult
> = ({
  setIsScrolledToTop,
  modalSelectedFilter,
  setModalSelectedFilter,
  filters,
  modalSelectedSortOption,
  onSortHandler,
  sortOptions,
  appliedCheckboxes,
  setAppliedCheckboxesCheckBoxGroupRemoveChip,
  setAppliedCheckboxesCheckBoxGroup,
  setAppliedCheckboxesSingleSelect,
  setTotalResults,
  modalPurchasesUrlParams,
  setModalAdditionalFilters,
  isToUseAuthZero
}) => {
  const ModalDivider = () => (
    <Box display="flex" height="10px" justifyContent="center">
      <Divider
        orientation="horizontal"
        width="100%"
        css={"background: secondary-light-grey;"}
      />
    </Box>
  );
  return (
    <Box
      overflowY="auto"
      flexGrow="1"
      px={5}
      pt={5}
      onScroll={(event) => {
        const top = event.target.scrollTop === 0;
        setIsScrolledToTop(top);
      }}
    >
      <DateRange
        selectedFilter={modalSelectedFilter}
        setSelectedFilter={setModalSelectedFilter}
        filters={filters}
      />
      <FilterCategories
        appliedCheckboxes={appliedCheckboxes}
        setAppliedCheckboxesCheckBoxGroup={setAppliedCheckboxesCheckBoxGroup}
        setAppliedCheckboxesCheckBoxGroupRemoveChip={
          setAppliedCheckboxesCheckBoxGroupRemoveChip
        }
        purchasesUrlQueryParams={modalPurchasesUrlParams}
        updateAdditionalFilters={setModalAdditionalFilters}
        setTotalResults={setTotalResults}
        setAppliedCheckboxesSingleSelect={setAppliedCheckboxesSingleSelect}
        isToUseAuthZero={isToUseAuthZero}
      />
      <ModalDivider />
      <SortOptionsMobile
        selectedSortOption={modalSelectedSortOption}
        setSelectedSortOption={onSortHandler}
        sortOptions={sortOptions}
      />
    </Box>
  );
};

export default Content;
